<template>
  <h1>
    <slot />
  </h1>
</template>